import type { SelectOption } from "./selectOption";

/** Lists with more options than this get a search box unless `searchable` says otherwise. */
export const SEARCH_THRESHOLD = 8;

/** Lower case without accents, so "Renée" matches "rene". */
export function normalizeLabel(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/** Options whose label contains every word of the query (accents and case ignored). */
export function filterOptions(options: SelectOption[], query: string): SelectOption[] {
  const words = normalizeLabel(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return options;
  return options.filter((o) => {
    const label = normalizeLabel(o.label);
    return words.every((w) => label.includes(w));
  });
}
